import gql from "graphql-tag";

const CREATE_SERVICE_MUTATION = gql`
  mutation CreateService(
    $assetIds: [Int]
    $serviceTypeId: Int!
    $frequencyId: Int
    $quantityKm: Float
    $percentageAlert: Int
    $emailsList: String
    $dateStart: Datetime
    $userIds: [Int]
  ) {
    createService(
      assetIds: $assetIds
      serviceTypeId: $serviceTypeId
      frequencyId: $frequencyId
      quantityKm: $quantityKm
      percentageAlert: $percentageAlert
      emailsList: $emailsList
      dateStart: $dateStart
      userIds: $userIds
    ) {
      id
      asset {
        id
        name
        licensePlate
      }
      serviceType {
        id
        description
      }
      frequency {
        id
        description
      }
      quantityKm
      percentageAlert
      emailsList
      warningDate
      warningKm
      dueDate
      actualOdo
      dueOdometer
      users {
        id
      }
    }
  }
`;

export default CREATE_SERVICE_MUTATION;
